import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '~/components';

import type { FiltersMetadata } from './types';

interface FilterButtonProps {
  filtersMetadata: FiltersMetadata;
  onShowFilters: (isOpen: boolean) => void;
}

export function FilterButton({
  filtersMetadata,
  onShowFilters,
}: FilterButtonProps) {
  const { t } = useTranslation('roster');

  const handleButtonClick = useCallback(() => {
    onShowFilters(true);
  }, [onShowFilters]);

  return (
    <button
      className="relative rounded-sm px-md py-sm leading-8 outline outline-1 duration-300 ease-out bg-emphasis-default outline-emphasis-subtle hover:bg-emphasis-strong hover:outline-emphasis-stronger"
      onClick={handleButtonClick}
      data-testid="artist-filter-button"
      aria-label={t('filters.buttonAriaLabel')}
    >
      <Icon
        type="sliders-simple"
        variant={filtersMetadata.areFiltersApplied ? 'solid' : 'light'}
        size="md"
      />
      {filtersMetadata.areFiltersApplied ? (
        <div
          data-testid="artist-filter-button-badge"
          className="absolute -right-1/4 -top-1/4 grid h-lg min-w-lg items-center rounded-full border p-xs text-caption-md leading-none bg-primary-default border-emphasis-subtle"
        >
          {filtersMetadata.filterCount}
        </div>
      ) : null}
    </button>
  );
}

FilterButton.displayName = 'FilterButton';
